export default function Laptop(props: any) {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_192_790)">
                <path
                    d="M3.60547 23.6416V7.10971C3.60547 6.34864 4.19812 5.73145 4.9294 5.73145H27.4262C28.1574 5.73145 28.7501 6.34864 28.7501 7.10971V23.6416"
                    stroke="#707070"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.2905 27.2695H2.06586C1.82013 27.2695 1.62109 27.0624 1.62109 26.8066L3.39 23.7284H28.5685L30.7353 26.8066C30.7353 27.0624 30.5363 27.2695 30.2905 27.2695Z"
                    stroke="#707070"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.543 7.35254H16.8157" stroke="#707070" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_192_790">
                    <rect width="32" height="32" fill="white" transform="translate(0.179688 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
